import {Component, inject, signal} from '@angular/core';
import {RecordData, SelectData} from "../../../types/records-table.types";
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {CommonModule} from "@angular/common";
import {contactResourceType} from "./configs/contacts-modal-config";
import {ContactsModalService} from "./services/contacts-modal.service";
import {ContactsDialogData} from "./types/contacts-modal.types";
import {LoadingService} from "../../../services/loading.service";
import {NewContactsModalComponent} from "./components/new-contacts-modal/new-contacts-modal.component";
import {CurrentContactsModalComponent} from "./components/current-contacts-modal/current-contacts-modal.component";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-contacts-modal',
  standalone: true,
  imports: [
    CommonModule,
    BaseModalComponent,
    NewContactsModalComponent,
    CurrentContactsModalComponent,
    LoaderComponent
  ],
  templateUrl: './contacts-modal.component.html',
  styleUrl: './contacts-modal.component.scss',
  providers: [ LoadingService ]
})
export class ContactsModalComponent extends BaseModalComponent {
  public contactsDialogData = inject<ContactsDialogData>(MAT_DIALOG_DATA);
  private contactsModalService: ContactsModalService = inject(ContactsModalService);

  public readonly contactResourceType = contactResourceType;
  public contactInfoValid = signal<boolean>(false);
  public telegramAccountIds = signal<Array<SelectData>>([]);

  public override async ngOnInit() {
    super.ngOnInit();
    await this.initModal();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(contactResourceType.path);
  }

  public async handleButtonClick(contactId: number | null): Promise<void> {
    const bloggerId = (this.contactsDialogData.recordData['bloggerContact'] as RecordData)['bloggerId'];
    this.contactsDialogData.recordData['bloggerContact'] = {
      id: contactId,
      valid: !!contactId,
      bloggerId: Number(bloggerId)
    };
    this.contactInfoValid.set(contactId !== null);
  }

  private async initModal(): Promise<void> {
    this.modalStatesService.openModal(contactResourceType.path);
    this.loadingService.setIsLoadingState(true);
    this.contactInfoValid.set(this.baseModalService.isModalValid(this.contactsDialogData.recordData, 'bloggerContact'));
    await this.contactsModalService.fetchTelegramAccountIds(this.contactsDialogData.recordData)
      .then((data) => this.telegramAccountIds.set(data))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
